import Link from '@material-ui/core/Link'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'
import { NavLink } from 'react-router-dom'

const useBreadcrumbItemStyles = makeStyles((theme: Theme) => ({
    trail: {
        color: '#000',
    },
    head: {
        ...theme.typography.h1,
        color: theme.palette.secondary.contrastText,
        cursor: 'default',
    },
}))

const BreadcrumbItem: React.FC<{
    title: string
    path?: string
}> = ({ title, path }) => {
    const classes = useBreadcrumbItemStyles()
    return (
        <Link
            data-testid={`breadcrumbItem${title.replace(/\s/g, '')}`}
            className={clsx(path ? classes.trail : classes.head)}
            component={path ? NavLink : Typography}
            to={path ?? undefined}
        >
            {title}
        </Link>
    )
}

export default BreadcrumbItem
